import { defineMessages } from 'react-intl';

export const pricingTiersTableMessages = defineMessages({
	currencyLabel: {
		id: 'PricingTiersTable.currencyLabel',
		defaultMessage: 'Currency',
	},
	userTierHeading: {
		id: 'PricingTiersTable.userTierHeading',
		defaultMessage: 'Number of users',
	},
	creatorTierHeading: {
		id: 'PricingTiersTable.creatorTierHeading',
		defaultMessage: 'Number of creators',
	},
	agentTierHeading: {
		id: 'PricingTiersTable.agentTierHeading',
		defaultMessage: 'Number of agents',
	},
	monthlyPriceHeading: {
		id: 'PricingTiersTable.monthlyPriceHeading',
		defaultMessage: 'Price per month',
	},
	annualPriceHeading: {
		id: 'PricingTiersTable.annualPriceHeading',
		defaultMessage: 'Annual price',
	},
	monthlyUserPrice: {
		id: 'PricingTiersTable.monthlyUserPrice',
		defaultMessage: '{price} /user',
	},
	monthlyCreatorPrice: {
		id: 'PricingTiersTable.monthlyCreatorPrice',
		defaultMessage: '{price} /creator',
	},
	monthlyAgentPrice: {
		id: 'PricingTiersTable.monthlyAgentPrice',
		defaultMessage: '{price} /agent',
	},
});
